// extracted by mini-css-extract-plugin
export default {"submitWrapper":"ConfirmationModal_submitWrapper__PVzF+"};